import { render, staticRenderFns } from "./policy-base.vue?vue&type=template&id=5ae01754&scoped=true&"
import script from "./policy-base.vue?vue&type=script&lang=ts&"
export * from "./policy-base.vue?vue&type=script&lang=ts&"
import style0 from "./policy-base.vue?vue&type=style&index=0&id=5ae01754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae01754",
  null
  
)

export default component.exports